import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { FieldTypeDropdownComponent }         from '../../components/Exports/FieldTypeDropdown.component';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-exportfield-edit',
  templateUrl: './ExportFieldEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => ExportFieldEditComponent)}]
})
export class ExportFieldEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @ViewChild(FieldTypeDropdownComponent) public fieldTypeDropdownComponent: FieldTypeDropdownComponent;

    @Input() public record: ent.ExportField;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
            'Header' : '',
            'CONAHeader' : '',
            'FieldType' : '',
            'FieldName' : '',
            'Value' : '',
            'EquipmentSequenceOverride' : ''
        };
        
        this.form = fb.group(group);
    }


    ngOnInit(): void {
        
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    fieldTypeChange(event: any){
        
        this.record.FieldTypeID = event;
    }

   
}